import { render, staticRenderFns } from "./PlayerRegistrationFormPaymentMethodCard.vue?vue&type=template&id=04bb7aa3&scoped=true&"
import script from "./PlayerRegistrationFormPaymentMethodCard.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormPaymentMethodCard.vue?vue&type=script&lang=js&"
import style0 from "./PlayerRegistrationFormPaymentMethodCard.vue?vue&type=style&index=0&id=04bb7aa3&prod&lang=css&"
import style1 from "./PlayerRegistrationFormPaymentMethodCard.vue?vue&type=style&index=1&id=04bb7aa3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04bb7aa3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMessages } from 'vuetify/lib/components/VMessages';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VBtn,VContainer,VMessages,VProgressCircular})
